// extracted by mini-css-extract-plugin
export default {"dialog":"WhiteboardContainerFullScreen_dialog__Ty48G"};